<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">User Logs</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content ref="contentDiv">
      <v-container grid-list-lg>
        <v-layout fluid wrap>
          <v-flex xs6 sm3>
            <v-text-field
              label="Search for"
              v-model="txtSearch"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm2>
            <v-text-field
              label="User Id"
              v-model="txtUserId"
            ></v-text-field>
          </v-flex>
          <v-flex xs5 sm3>
            <v-menu
              ref="menu1"
              :close-on-content-click="false"
              v-model="dtPicker1"
              :nudge-right="40"
              :return-value.sync="date1"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="date1"
                label="Date from"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="date1" no-title scrollable @input="$refs.menu1.save(date1)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs5 sm3>
            <v-menu
              ref="menu2"
              :close-on-content-click="false"
              v-model="dtPicker2"
              :nudge-right="40"
              :return-value.sync="date2"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="date2"
                label="Date to"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="date2" no-title scrollable @input="$refs.menu2.save(date2)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2 sm1>
            <v-btn
              icon
              @click="getLogs(txtUserId, txtSearch, date1, date2)"
            >
              <v-icon>search</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 class="text-xs-center">
            <v-data-table
              :items="logs"
              hide-actions
              class="elevation-1"
            >
              <template slot="headers">
                <tr>
                  <th class="text-xs-center subheading font-weight-bold">
                    Date
                  </th>
                  <th class="text-xs-center hidden-xs-only subheading font-weight-bold">
                    User
                  </th>
                  <th class="text-xs-left subheading font-weight-bold">
                    Details
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr :class="(props.index % 2 === 0 ? 'row1' : 'row2')">
                  <td class="text-xs-center">{{ props.item.createdDateTime | formatDate('DD MMMM YYYY HH:mm:ss', profile.gmtTimezone) }}</td>
                  <td class="text-xs-center">
                    <div>{{ props.item.loginEmail }}</div>
                    <div v-if="props.item.parentStoreName"><strong>{{ props.item.parentStoreName }}</strong></div>
                    <div v-else-if="props.item.storeName"><strong>{{ props.item.storeName }}</strong></div>
                    <div v-if="props.item.parentType"><strong>({{ props.item.parentType | allCaps }})</strong></div>
                    <div v-else-if="props.item.userType"><strong>({{ props.item.userType | allCaps }})</strong></div>
                  </td>
                  <td class="text-xs-left pt-3 pb-3">
                    <div class="mt-2 mb-3"><strong>{{ props.item.url }}</strong></div>
                    <div>{{ props.item.details | truncate(300) }}</div>
                  </td>
                  <td class="text-xs-center">
                    <v-btn
                      small
                      outline
                      @click="viewLogDetails(props.item.id)"
                    >
                      View
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-center pt-3">
            Showing {{ listOffset + 1 }} - {{ listOffset + logs.length }} of {{ listTotal }}
          </v-flex>
          <v-flex sm3 xs6>
            <v-btn
              block
              outline
              :disabled="listOffset <= 0"
              @click="getLogs(txtUserId, txtSearch, date1, date2, '', (listOffset-listLimit <= 0 ? 0 : listOffset-listLimit))"
            >
              Prev
            </v-btn>
          </v-flex>
          <v-flex sm3 xs6>
            <v-btn
              block
              outline
              :disabled="listOffset + listLimit >= listTotal"
              @click="getLogs(txtUserId, txtSearch, date1, date2, '', listOffset+listLimit)"
            >
              Next
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog v-model="dialogViewDetails" @keydown.esc="dialogViewDetails = false" max-width="900px">
        <v-card>
          <v-card-title>
            <h3 class="headline font-weight-bold mb-0">Log Details</h3>
          </v-card-title>
          <v-card-text>
            <strong>URL:</strong> {{ viewUrl }}
            <div style="width:100%;overflow:scroll;min-height:200px;max-height:500px;border:1px solid #999999;">
              {{ viewDetails }}
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import axios from 'axios'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      user: null,
      drawer: false,
      loading: false,
      dialogViewDetails: false,
      viewUrl: '',
      viewDetails: '',
      txtSearch: '',
      txtUserId: '',
      date1: '',
      date2: '',
      dtPicker1: false,
      dtPicker2: false,
      logs: [],
      listLimit: 10,
      listOffset: 0,
      listTotal: 0
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getLogs()
    this.disableBottomDetector()
  },

  methods: {
    viewLogDetails: function (logId) {
      var isFound = false
      for (var i in this.logs) {
        if (this.logs[i].id === logId) {
          this.viewDetails = this.logs[i].details
          this.viewUrl = this.logs[i].url
          isFound = true
          this.dialogViewDetails = true
          break
        }
      }

      if (!isFound) {
        window.alert('Invalid log Id')
      }
    },
    getLogs: function (userId = '', search = '', date1 = '', date2 = '', sort = '', offset = 0) {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/user/logs?user_id=' + userId + '&search=' + search + '&date1=' + date1 + '&date2=' + date2 + '&sort=' + sort + '&offset=' + offset)
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.logs = resp.data.data
              _this.listLimit = resp.data.limit
              _this.listOffset = resp.data.offset
              _this.listTotal = resp.data.total
            } else {
              console.log('unable to load logs: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    }
  }
}
</script>
